module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/man-mobile@2x_3b802c.png";